import { Editor } from "grapesjs";
import { RequiredPluginOptions } from "../../../../../types/types";
import { html } from "../../../../../utils/tw";

export default async (editor: Editor, opts: RequiredPluginOptions) => {
  const { Components } = editor;

  Components.addType("testimonials", {
    isComponent: (el) => {
      if (
        el.className &&
        typeof el.className === "string" &&
        el.className.includes("testimonial")
      ) {
        return {
          type: "testimonials",
        };
      }
    },
    model: {
      defaults: {
        components: /*html*/ `
          <section class=" my-6 px-4 w-full testimonial ">
            <div class="container mx-auto">
              <div class="grid md:grid-cols-2 gap-x-24 gap-y-2 items-center">
                <div class="space-y-2 ">
                  <h3 class="md:text-3xl text-2xl font-semibold">
                    Testimonials
                  </h3>
                  <p class="md:text-xl ">Hear from Our CEO & Happy Customers</p>
                </div>
                <div
                  class="px-6 py-6 bg-[#F4F4F4] flex flex-col gap-y-4 items-center text-center"
                >
                  <img
                    src="https://via.placeholder.com/100"
                    alt="CEO"
                    class="w-20 h-20 rounded-full"
                  />
                  <div class="">
                    <p class="font-semibold">Nisant</p>
                    <p>Project Manager of XYZ</p>
                  </div>
                  <p>
                    We specialize in software, web development, IT consulting,
                    and cloud services
                  </p>
                </div>
              </div>
            </div>
          </section>
          <section class="my-6">
            <div
              class="flex w-full justify-end gap-x-4 container mx-auto my-4 md:px-0 px-4 "
            >
              <div
                class="border-2 md:p-3 p-2 rounded-lg button-prev cursor-pointer transition-all hover:bg-gray-200 active:scale-95"
              >
                <svg
                  class="md:w-[27px] md:h-[19px] w-8 h-3"
                  viewBox="0 0 27 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M25.3223 8.27119C25.985 8.27119 26.5223 8.80845 26.5223 9.47119C26.5223 10.1339 25.985 10.6712 25.3223 10.6712L25.3223 8.27119ZM0.473738 10.3197C0.00510975 9.85109 0.00510982 9.09129 0.473738 8.62266L8.11049 0.985908C8.57912 0.517279 9.33892 0.517279 9.80755 0.985908C10.2762 1.45454 10.2762 2.21434 9.80755 2.68296L3.01932 9.47119L9.80755 16.2594C10.2762 16.728 10.2762 17.4878 9.80755 17.9565C9.33892 18.4251 8.57912 18.4251 8.11049 17.9565L0.473738 10.3197ZM25.3223 10.6712L1.32227 10.6712L1.32227 8.27119L25.3223 8.27119L25.3223 10.6712Z"
                    fill="currentColor"
                  ></path>
                </svg>
              </div>
              <div
                class="border-2 md:p-3 p-2 rounded-lg button-next cursor-pointer transition-all hover:bg-gray-200 active:scale-95"
              >
                <svg
                  class="md:w-[27px] md:h-[19px] w-8 h-3"
                  viewBox="0 0 28 19"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M2.12207 8.27119C1.45933 8.27119 0.92207 8.80845 0.92207 9.47119C0.92207 10.1339 1.45933 10.6712 2.12207 10.6712L2.12207 8.27119ZM26.9706 10.3197C27.4392 9.85109 27.4392 9.09129 26.9706 8.62266L19.3338 0.985908C18.8652 0.517279 18.1054 0.517279 17.6368 0.985908C17.1682 1.45454 17.1682 2.21434 17.6368 2.68296L24.425 9.47119L17.6368 16.2594C17.1682 16.728 17.1682 17.4878 17.6368 17.9565C18.1054 18.4251 18.8652 18.4251 19.3338 17.9565L26.9706 10.3197ZM2.12207 10.6712L26.1221 10.6712L26.1221 8.27119L2.12207 8.27119L2.12207 10.6712Z"
                    fill="currentColor"
                  ></path>
                </svg>
              </div>
            </div>
            <div class="bg-[#F4F4F4] px-4 py-10">
              <div class="swiper MySwiper container mx-auto  ">
                <div class="swiper-wrapper ">
                  <div class="swiper-slide  relative">
                    <div class="rounded-lg bg-white py-6">
                      <div class="flex gap-x-1 justify-center py-2">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 43 44"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M41.7192 18.0126H26.4704L21.7426 3.22998L17.0148 18.0126H1.76602L14.0849 27.1353L9.42371 41.8514L21.7426 32.7287L34.0615 41.8514L29.3337 27.0687L41.7192 18.0126Z"
                            fill="#FECC2B"
                          />
                        </svg>
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 43 44"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M41.7192 18.0126H26.4704L21.7426 3.22998L17.0148 18.0126H1.76602L14.0849 27.1353L9.42371 41.8514L21.7426 32.7287L34.0615 41.8514L29.3337 27.0687L41.7192 18.0126Z"
                            fill="#FECC2B"
                          />
                        </svg>
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 43 44"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M41.7192 18.0126H26.4704L21.7426 3.22998L17.0148 18.0126H1.76602L14.0849 27.1353L9.42371 41.8514L21.7426 32.7287L34.0615 41.8514L29.3337 27.0687L41.7192 18.0126Z"
                            fill="#FECC2B"
                          />
                        </svg>
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 43 44"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M41.7192 18.0126H26.4704L21.7426 3.22998L17.0148 18.0126H1.76602L14.0849 27.1353L9.42371 41.8514L21.7426 32.7287L34.0615 41.8514L29.3337 27.0687L41.7192 18.0126Z"
                            fill="#FECC2B"
                          />
                        </svg>
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 43 44"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M41.7192 18.0126H26.4704L21.7426 3.22998L17.0148 18.0126H1.76602L14.0849 27.1353L9.42371 41.8514L21.7426 32.7287L34.0615 41.8514L29.3337 27.0687L41.7192 18.0126Z"
                            fill="#FECC2B"
                          />
                        </svg>
                      </div>
                      <div class="flex w-full justify-between  ">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 43 27"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_2_1639)">
                            <path
                              d="M40.3062 0.777361C40.3062 1.38492 40.3544 1.89396 40.2843 2.38548C40.2548 2.59457 40.0106 2.81899 39.8103 2.94488C38.8393 3.5612 37.7851 4.05382 36.8798 4.761C33.9504 7.05112 32.2141 10.0659 32.1189 13.9828C32.0926 15.0939 32.5021 15.3731 33.4347 14.9385C36.131 13.6883 39.0309 14.4218 40.5777 16.7447C42.2646 19.2801 42.0271 22.6561 40.0052 24.8696C37.4239 27.6962 33.1742 27.7816 30.2437 25.0798C28.4889 23.4619 27.6547 21.3732 27.4467 18.9965C26.7494 11.0369 30.7418 4.47528 38.0095 1.59292C38.7287 1.30829 39.4655 1.07403 40.3062 0.777361Z"
                              fill="#949494"
                            />
                          </g>
                          <g clip-path="url(#clip1_2_1639)">
                            <path
                              d="M24.9804 0.777605C24.9804 1.38517 25.0286 1.89421 24.9585 2.38573C24.9289 2.59482 24.6848 2.81923 24.4845 2.94512C23.5135 3.56144 22.4593 4.05406 21.554 4.76124C18.6245 7.05136 16.8883 10.0662 16.7931 13.983C16.7668 15.0942 17.1762 15.3733 18.1089 14.9387C20.8052 13.6886 23.7051 14.422 25.2519 16.745C26.9388 19.2803 26.7013 22.6564 24.6793 24.8699C22.098 27.6964 17.8484 27.7818 14.9179 25.0801C13.163 23.4621 12.3289 21.3734 12.1209 18.9968C11.4236 11.0372 15.4159 4.47552 22.6837 1.59316C23.4029 1.30854 24.1397 1.07427 24.9804 0.777605Z"
                              fill="#949494"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_2_1639">
                              <rect
                                width="26.2729"
                                height="26.2729"
                                fill="white"
                                transform="matrix(-1 0 0 -1 42.1965 26.5371)"
                              />
                            </clipPath>
                            <clipPath id="clip1_2_1639">
                              <rect
                                width="26.2729"
                                height="26.2729"
                                fill="white"
                                transform="matrix(-1 0 0 -1 26.8708 26.5374)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 42 27"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_2_1644)">
                            <path
                              d="M2.08676 27.0505C2.08676 26.443 2.0386 25.9339 2.10866 25.4424C2.13821 25.2333 2.38233 25.0089 2.58266 24.883C3.55367 24.2667 4.60787 23.7741 5.51319 23.0669C8.44262 20.7768 10.1788 17.7619 10.2741 13.8451C10.3003 12.734 9.89092 12.4548 8.95823 12.8894C6.26197 14.1396 3.36209 13.4061 1.81528 11.0831C0.128335 8.5478 0.365885 5.17173 2.38781 2.95824C4.96912 0.131706 9.21877 0.0463194 12.1493 2.74805C13.9041 4.36603 14.7383 6.45473 14.9463 8.83133C15.6436 16.7909 11.6512 23.3526 4.38345 26.235C3.66423 26.5196 2.9275 26.7539 2.08676 27.0505Z"
                              fill="#949494"
                            />
                          </g>
                          <g clip-path="url(#clip1_2_1644)">
                            <path
                              d="M17.4128 27.0505C17.4128 26.443 17.3646 25.9339 17.4347 25.4424C17.4643 25.2333 17.7084 25.0089 17.9087 24.883C18.8797 24.2667 19.9339 23.7741 20.8392 23.0669C23.7687 20.7768 25.5049 17.7619 25.6001 13.8451C25.6264 12.734 25.217 12.4548 24.2843 12.8894C21.588 14.1396 18.6881 13.4061 17.1413 11.0831C15.4544 8.5478 15.6919 5.17173 17.7139 2.95824C20.2952 0.131706 24.5448 0.0463194 27.4753 2.74805C29.2302 4.36603 30.0643 6.45473 30.2723 8.83133C30.9696 16.7909 26.9773 23.3526 19.7095 26.235C18.9903 26.5196 18.2535 26.7539 17.4128 27.0505Z"
                              fill="#949494"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_2_1644">
                              <rect
                                width="26.2729"
                                height="26.2729"
                                fill="white"
                                transform="translate(0.196472 0.26416)"
                              />
                            </clipPath>
                            <clipPath id="clip1_2_1644">
                              <rect
                                width="26.2729"
                                height="26.2729"
                                fill="white"
                                transform="translate(15.5222 0.26416)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <div class="px-8">
                        <p class="text-justify  ">
                          Logistics Master has transformed our supply chain with
                          their efficiency and professionalism. Highly
                          recommended!
                        </p>
                        <p class="mt-1 font-semibold">Nischal Basnet</p>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-slide  relative">
                    <div class="rounded-lg bg-white py-6">
                      <div class="flex gap-x-1 justify-center py-2">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 43 44"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M41.7192 18.0126H26.4704L21.7426 3.22998L17.0148 18.0126H1.76602L14.0849 27.1353L9.42371 41.8514L21.7426 32.7287L34.0615 41.8514L29.3337 27.0687L41.7192 18.0126Z"
                            fill="#FECC2B"
                          />
                        </svg>
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 43 44"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M41.7192 18.0126H26.4704L21.7426 3.22998L17.0148 18.0126H1.76602L14.0849 27.1353L9.42371 41.8514L21.7426 32.7287L34.0615 41.8514L29.3337 27.0687L41.7192 18.0126Z"
                            fill="#FECC2B"
                          />
                        </svg>
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 43 44"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M41.7192 18.0126H26.4704L21.7426 3.22998L17.0148 18.0126H1.76602L14.0849 27.1353L9.42371 41.8514L21.7426 32.7287L34.0615 41.8514L29.3337 27.0687L41.7192 18.0126Z"
                            fill="#FECC2B"
                          />
                        </svg>
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 43 44"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M41.7192 18.0126H26.4704L21.7426 3.22998L17.0148 18.0126H1.76602L14.0849 27.1353L9.42371 41.8514L21.7426 32.7287L34.0615 41.8514L29.3337 27.0687L41.7192 18.0126Z"
                            fill="#FECC2B"
                          />
                        </svg>
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 43 44"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M41.7192 18.0126H26.4704L21.7426 3.22998L17.0148 18.0126H1.76602L14.0849 27.1353L9.42371 41.8514L21.7426 32.7287L34.0615 41.8514L29.3337 27.0687L41.7192 18.0126Z"
                            fill="#FECC2B"
                          />
                        </svg>
                      </div>
                      <div class="flex w-full justify-between  ">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 43 27"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_2_1639)">
                            <path
                              d="M40.3062 0.777361C40.3062 1.38492 40.3544 1.89396 40.2843 2.38548C40.2548 2.59457 40.0106 2.81899 39.8103 2.94488C38.8393 3.5612 37.7851 4.05382 36.8798 4.761C33.9504 7.05112 32.2141 10.0659 32.1189 13.9828C32.0926 15.0939 32.5021 15.3731 33.4347 14.9385C36.131 13.6883 39.0309 14.4218 40.5777 16.7447C42.2646 19.2801 42.0271 22.6561 40.0052 24.8696C37.4239 27.6962 33.1742 27.7816 30.2437 25.0798C28.4889 23.4619 27.6547 21.3732 27.4467 18.9965C26.7494 11.0369 30.7418 4.47528 38.0095 1.59292C38.7287 1.30829 39.4655 1.07403 40.3062 0.777361Z"
                              fill="#949494"
                            />
                          </g>
                          <g clip-path="url(#clip1_2_1639)">
                            <path
                              d="M24.9804 0.777605C24.9804 1.38517 25.0286 1.89421 24.9585 2.38573C24.9289 2.59482 24.6848 2.81923 24.4845 2.94512C23.5135 3.56144 22.4593 4.05406 21.554 4.76124C18.6245 7.05136 16.8883 10.0662 16.7931 13.983C16.7668 15.0942 17.1762 15.3733 18.1089 14.9387C20.8052 13.6886 23.7051 14.422 25.2519 16.745C26.9388 19.2803 26.7013 22.6564 24.6793 24.8699C22.098 27.6964 17.8484 27.7818 14.9179 25.0801C13.163 23.4621 12.3289 21.3734 12.1209 18.9968C11.4236 11.0372 15.4159 4.47552 22.6837 1.59316C23.4029 1.30854 24.1397 1.07427 24.9804 0.777605Z"
                              fill="#949494"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_2_1639">
                              <rect
                                width="26.2729"
                                height="26.2729"
                                fill="white"
                                transform="matrix(-1 0 0 -1 42.1965 26.5371)"
                              />
                            </clipPath>
                            <clipPath id="clip1_2_1639">
                              <rect
                                width="26.2729"
                                height="26.2729"
                                fill="white"
                                transform="matrix(-1 0 0 -1 26.8708 26.5374)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 42 27"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_2_1644)">
                            <path
                              d="M2.08676 27.0505C2.08676 26.443 2.0386 25.9339 2.10866 25.4424C2.13821 25.2333 2.38233 25.0089 2.58266 24.883C3.55367 24.2667 4.60787 23.7741 5.51319 23.0669C8.44262 20.7768 10.1788 17.7619 10.2741 13.8451C10.3003 12.734 9.89092 12.4548 8.95823 12.8894C6.26197 14.1396 3.36209 13.4061 1.81528 11.0831C0.128335 8.5478 0.365885 5.17173 2.38781 2.95824C4.96912 0.131706 9.21877 0.0463194 12.1493 2.74805C13.9041 4.36603 14.7383 6.45473 14.9463 8.83133C15.6436 16.7909 11.6512 23.3526 4.38345 26.235C3.66423 26.5196 2.9275 26.7539 2.08676 27.0505Z"
                              fill="#949494"
                            />
                          </g>
                          <g clip-path="url(#clip1_2_1644)">
                            <path
                              d="M17.4128 27.0505C17.4128 26.443 17.3646 25.9339 17.4347 25.4424C17.4643 25.2333 17.7084 25.0089 17.9087 24.883C18.8797 24.2667 19.9339 23.7741 20.8392 23.0669C23.7687 20.7768 25.5049 17.7619 25.6001 13.8451C25.6264 12.734 25.217 12.4548 24.2843 12.8894C21.588 14.1396 18.6881 13.4061 17.1413 11.0831C15.4544 8.5478 15.6919 5.17173 17.7139 2.95824C20.2952 0.131706 24.5448 0.0463194 27.4753 2.74805C29.2302 4.36603 30.0643 6.45473 30.2723 8.83133C30.9696 16.7909 26.9773 23.3526 19.7095 26.235C18.9903 26.5196 18.2535 26.7539 17.4128 27.0505Z"
                              fill="#949494"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_2_1644">
                              <rect
                                width="26.2729"
                                height="26.2729"
                                fill="white"
                                transform="translate(0.196472 0.26416)"
                              />
                            </clipPath>
                            <clipPath id="clip1_2_1644">
                              <rect
                                width="26.2729"
                                height="26.2729"
                                fill="white"
                                transform="translate(15.5222 0.26416)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <div class="px-8">
                        <p class="text-justify  ">
                          Logistics Master has transformed our supply chain with
                          their efficiency and professionalism. Highly
                          recommended!
                        </p>
                        <p class="mt-1 font-semibold">Nischal Basnet</p>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-slide  relative">
                    <div class="rounded-lg bg-white py-6">
                      <div class="flex gap-x-1 justify-center py-2">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 43 44"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M41.7192 18.0126H26.4704L21.7426 3.22998L17.0148 18.0126H1.76602L14.0849 27.1353L9.42371 41.8514L21.7426 32.7287L34.0615 41.8514L29.3337 27.0687L41.7192 18.0126Z"
                            fill="#FECC2B"
                          />
                        </svg>
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 43 44"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M41.7192 18.0126H26.4704L21.7426 3.22998L17.0148 18.0126H1.76602L14.0849 27.1353L9.42371 41.8514L21.7426 32.7287L34.0615 41.8514L29.3337 27.0687L41.7192 18.0126Z"
                            fill="#FECC2B"
                          />
                        </svg>
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 43 44"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M41.7192 18.0126H26.4704L21.7426 3.22998L17.0148 18.0126H1.76602L14.0849 27.1353L9.42371 41.8514L21.7426 32.7287L34.0615 41.8514L29.3337 27.0687L41.7192 18.0126Z"
                            fill="#FECC2B"
                          />
                        </svg>
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 43 44"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M41.7192 18.0126H26.4704L21.7426 3.22998L17.0148 18.0126H1.76602L14.0849 27.1353L9.42371 41.8514L21.7426 32.7287L34.0615 41.8514L29.3337 27.0687L41.7192 18.0126Z"
                            fill="#FECC2B"
                          />
                        </svg>
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 43 44"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M41.7192 18.0126H26.4704L21.7426 3.22998L17.0148 18.0126H1.76602L14.0849 27.1353L9.42371 41.8514L21.7426 32.7287L34.0615 41.8514L29.3337 27.0687L41.7192 18.0126Z"
                            fill="#FECC2B"
                          />
                        </svg>
                      </div>
                      <div class="flex w-full justify-between  ">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 43 27"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_2_1639)">
                            <path
                              d="M40.3062 0.777361C40.3062 1.38492 40.3544 1.89396 40.2843 2.38548C40.2548 2.59457 40.0106 2.81899 39.8103 2.94488C38.8393 3.5612 37.7851 4.05382 36.8798 4.761C33.9504 7.05112 32.2141 10.0659 32.1189 13.9828C32.0926 15.0939 32.5021 15.3731 33.4347 14.9385C36.131 13.6883 39.0309 14.4218 40.5777 16.7447C42.2646 19.2801 42.0271 22.6561 40.0052 24.8696C37.4239 27.6962 33.1742 27.7816 30.2437 25.0798C28.4889 23.4619 27.6547 21.3732 27.4467 18.9965C26.7494 11.0369 30.7418 4.47528 38.0095 1.59292C38.7287 1.30829 39.4655 1.07403 40.3062 0.777361Z"
                              fill="#949494"
                            />
                          </g>
                          <g clip-path="url(#clip1_2_1639)">
                            <path
                              d="M24.9804 0.777605C24.9804 1.38517 25.0286 1.89421 24.9585 2.38573C24.9289 2.59482 24.6848 2.81923 24.4845 2.94512C23.5135 3.56144 22.4593 4.05406 21.554 4.76124C18.6245 7.05136 16.8883 10.0662 16.7931 13.983C16.7668 15.0942 17.1762 15.3733 18.1089 14.9387C20.8052 13.6886 23.7051 14.422 25.2519 16.745C26.9388 19.2803 26.7013 22.6564 24.6793 24.8699C22.098 27.6964 17.8484 27.7818 14.9179 25.0801C13.163 23.4621 12.3289 21.3734 12.1209 18.9968C11.4236 11.0372 15.4159 4.47552 22.6837 1.59316C23.4029 1.30854 24.1397 1.07427 24.9804 0.777605Z"
                              fill="#949494"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_2_1639">
                              <rect
                                width="26.2729"
                                height="26.2729"
                                fill="white"
                                transform="matrix(-1 0 0 -1 42.1965 26.5371)"
                              />
                            </clipPath>
                            <clipPath id="clip1_2_1639">
                              <rect
                                width="26.2729"
                                height="26.2729"
                                fill="white"
                                transform="matrix(-1 0 0 -1 26.8708 26.5374)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 42 27"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_2_1644)">
                            <path
                              d="M2.08676 27.0505C2.08676 26.443 2.0386 25.9339 2.10866 25.4424C2.13821 25.2333 2.38233 25.0089 2.58266 24.883C3.55367 24.2667 4.60787 23.7741 5.51319 23.0669C8.44262 20.7768 10.1788 17.7619 10.2741 13.8451C10.3003 12.734 9.89092 12.4548 8.95823 12.8894C6.26197 14.1396 3.36209 13.4061 1.81528 11.0831C0.128335 8.5478 0.365885 5.17173 2.38781 2.95824C4.96912 0.131706 9.21877 0.0463194 12.1493 2.74805C13.9041 4.36603 14.7383 6.45473 14.9463 8.83133C15.6436 16.7909 11.6512 23.3526 4.38345 26.235C3.66423 26.5196 2.9275 26.7539 2.08676 27.0505Z"
                              fill="#949494"
                            />
                          </g>
                          <g clip-path="url(#clip1_2_1644)">
                            <path
                              d="M17.4128 27.0505C17.4128 26.443 17.3646 25.9339 17.4347 25.4424C17.4643 25.2333 17.7084 25.0089 17.9087 24.883C18.8797 24.2667 19.9339 23.7741 20.8392 23.0669C23.7687 20.7768 25.5049 17.7619 25.6001 13.8451C25.6264 12.734 25.217 12.4548 24.2843 12.8894C21.588 14.1396 18.6881 13.4061 17.1413 11.0831C15.4544 8.5478 15.6919 5.17173 17.7139 2.95824C20.2952 0.131706 24.5448 0.0463194 27.4753 2.74805C29.2302 4.36603 30.0643 6.45473 30.2723 8.83133C30.9696 16.7909 26.9773 23.3526 19.7095 26.235C18.9903 26.5196 18.2535 26.7539 17.4128 27.0505Z"
                              fill="#949494"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_2_1644">
                              <rect
                                width="26.2729"
                                height="26.2729"
                                fill="white"
                                transform="translate(0.196472 0.26416)"
                              />
                            </clipPath>
                            <clipPath id="clip1_2_1644">
                              <rect
                                width="26.2729"
                                height="26.2729"
                                fill="white"
                                transform="translate(15.5222 0.26416)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <div class="px-8">
                        <p class="text-justify  ">
                          Logistics Master has transformed our supply chain with
                          their efficiency and professionalism. Highly
                          recommended!
                        </p>
                        <p class="mt-1 font-semibold">Nischal Basnet</p>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-slide  relative">
                    <div class="rounded-lg bg-white py-6">
                      <div class="flex gap-x-1 justify-center py-2">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 43 44"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M41.7192 18.0126H26.4704L21.7426 3.22998L17.0148 18.0126H1.76602L14.0849 27.1353L9.42371 41.8514L21.7426 32.7287L34.0615 41.8514L29.3337 27.0687L41.7192 18.0126Z"
                            fill="#FECC2B"
                          />
                        </svg>
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 43 44"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M41.7192 18.0126H26.4704L21.7426 3.22998L17.0148 18.0126H1.76602L14.0849 27.1353L9.42371 41.8514L21.7426 32.7287L34.0615 41.8514L29.3337 27.0687L41.7192 18.0126Z"
                            fill="#FECC2B"
                          />
                        </svg>
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 43 44"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M41.7192 18.0126H26.4704L21.7426 3.22998L17.0148 18.0126H1.76602L14.0849 27.1353L9.42371 41.8514L21.7426 32.7287L34.0615 41.8514L29.3337 27.0687L41.7192 18.0126Z"
                            fill="#FECC2B"
                          />
                        </svg>
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 43 44"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M41.7192 18.0126H26.4704L21.7426 3.22998L17.0148 18.0126H1.76602L14.0849 27.1353L9.42371 41.8514L21.7426 32.7287L34.0615 41.8514L29.3337 27.0687L41.7192 18.0126Z"
                            fill="#FECC2B"
                          />
                        </svg>
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 43 44"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M41.7192 18.0126H26.4704L21.7426 3.22998L17.0148 18.0126H1.76602L14.0849 27.1353L9.42371 41.8514L21.7426 32.7287L34.0615 41.8514L29.3337 27.0687L41.7192 18.0126Z"
                            fill="#FECC2B"
                          />
                        </svg>
                      </div>
                      <div class="flex w-full justify-between  ">
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 43 27"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_2_1639)">
                            <path
                              d="M40.3062 0.777361C40.3062 1.38492 40.3544 1.89396 40.2843 2.38548C40.2548 2.59457 40.0106 2.81899 39.8103 2.94488C38.8393 3.5612 37.7851 4.05382 36.8798 4.761C33.9504 7.05112 32.2141 10.0659 32.1189 13.9828C32.0926 15.0939 32.5021 15.3731 33.4347 14.9385C36.131 13.6883 39.0309 14.4218 40.5777 16.7447C42.2646 19.2801 42.0271 22.6561 40.0052 24.8696C37.4239 27.6962 33.1742 27.7816 30.2437 25.0798C28.4889 23.4619 27.6547 21.3732 27.4467 18.9965C26.7494 11.0369 30.7418 4.47528 38.0095 1.59292C38.7287 1.30829 39.4655 1.07403 40.3062 0.777361Z"
                              fill="#949494"
                            />
                          </g>
                          <g clip-path="url(#clip1_2_1639)">
                            <path
                              d="M24.9804 0.777605C24.9804 1.38517 25.0286 1.89421 24.9585 2.38573C24.9289 2.59482 24.6848 2.81923 24.4845 2.94512C23.5135 3.56144 22.4593 4.05406 21.554 4.76124C18.6245 7.05136 16.8883 10.0662 16.7931 13.983C16.7668 15.0942 17.1762 15.3733 18.1089 14.9387C20.8052 13.6886 23.7051 14.422 25.2519 16.745C26.9388 19.2803 26.7013 22.6564 24.6793 24.8699C22.098 27.6964 17.8484 27.7818 14.9179 25.0801C13.163 23.4621 12.3289 21.3734 12.1209 18.9968C11.4236 11.0372 15.4159 4.47552 22.6837 1.59316C23.4029 1.30854 24.1397 1.07427 24.9804 0.777605Z"
                              fill="#949494"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_2_1639">
                              <rect
                                width="26.2729"
                                height="26.2729"
                                fill="white"
                                transform="matrix(-1 0 0 -1 42.1965 26.5371)"
                              />
                            </clipPath>
                            <clipPath id="clip1_2_1639">
                              <rect
                                width="26.2729"
                                height="26.2729"
                                fill="white"
                                transform="matrix(-1 0 0 -1 26.8708 26.5374)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 42 27"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_2_1644)">
                            <path
                              d="M2.08676 27.0505C2.08676 26.443 2.0386 25.9339 2.10866 25.4424C2.13821 25.2333 2.38233 25.0089 2.58266 24.883C3.55367 24.2667 4.60787 23.7741 5.51319 23.0669C8.44262 20.7768 10.1788 17.7619 10.2741 13.8451C10.3003 12.734 9.89092 12.4548 8.95823 12.8894C6.26197 14.1396 3.36209 13.4061 1.81528 11.0831C0.128335 8.5478 0.365885 5.17173 2.38781 2.95824C4.96912 0.131706 9.21877 0.0463194 12.1493 2.74805C13.9041 4.36603 14.7383 6.45473 14.9463 8.83133C15.6436 16.7909 11.6512 23.3526 4.38345 26.235C3.66423 26.5196 2.9275 26.7539 2.08676 27.0505Z"
                              fill="#949494"
                            />
                          </g>
                          <g clip-path="url(#clip1_2_1644)">
                            <path
                              d="M17.4128 27.0505C17.4128 26.443 17.3646 25.9339 17.4347 25.4424C17.4643 25.2333 17.7084 25.0089 17.9087 24.883C18.8797 24.2667 19.9339 23.7741 20.8392 23.0669C23.7687 20.7768 25.5049 17.7619 25.6001 13.8451C25.6264 12.734 25.217 12.4548 24.2843 12.8894C21.588 14.1396 18.6881 13.4061 17.1413 11.0831C15.4544 8.5478 15.6919 5.17173 17.7139 2.95824C20.2952 0.131706 24.5448 0.0463194 27.4753 2.74805C29.2302 4.36603 30.0643 6.45473 30.2723 8.83133C30.9696 16.7909 26.9773 23.3526 19.7095 26.235C18.9903 26.5196 18.2535 26.7539 17.4128 27.0505Z"
                              fill="#949494"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_2_1644">
                              <rect
                                width="26.2729"
                                height="26.2729"
                                fill="white"
                                transform="translate(0.196472 0.26416)"
                              />
                            </clipPath>
                            <clipPath id="clip1_2_1644">
                              <rect
                                width="26.2729"
                                height="26.2729"
                                fill="white"
                                transform="translate(15.5222 0.26416)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      </div>
                      <div class="px-8">
                        <p class="text-justify  ">
                          Logistics Master has transformed our supply chain with
                          their efficiency and professionalism. Highly
                          recommended!
                        </p>
                        <p class="mt-1 font-semibold">Nischal Basnet</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        `,

        script: function () {
          const initLib = function () {
            //@ts-ignore
            const swiper = new Swiper(".MySwiper", {
              direction: "horizontal",
              slidesPerView: 1,
              spaceBetween: 20,
              loop: true,
              autoplay: true,
              breakpoints: {
                640: {
                  slidesPerView: 1,
                  spaceBetween: 10,
                },
                768: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 20,
                },
              },
              navigation: {
                nextEl: ".button-next",
                prevEl: ".button-prev",
              },
            });
          };

          const prevButton = document.querySelector(".button-prev");
          const nextButton = document.querySelector(".button-next");

          prevButton.addEventListener("click", () => {
            prevButton.classList.add("opacity-50");
            setTimeout(() => prevButton.classList.remove("opacity-50"), 200);
          });

          nextButton.addEventListener("click", () => {
            nextButton.classList.add("opacity-50");
            setTimeout(() => nextButton.classList.remove("opacity-50"), 200);
          });
          //@ts-ignore
          if (typeof Swiper === "undefined") {
            const script = document.createElement("script");
            script.onload = initLib;
            script.src =
              "https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js";
            document.body.appendChild(script);
          } else {
            initLib();
          }
        },
      },
    },
  });
};
